






















import {
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import { Home } from "@/admin/route-names";
import { useUserStore } from "@/shared/store/user";
import { OktaSignInWidgetBuilder } from "@/shared/oktaSignInWidgetWrapper";
import { LoginRouteNames } from "@/shared/loginRoutes";
import { AuthType } from "@/shared/types";
import { useThemeStore } from "@/shared/store/theme";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { employerLogin as employerLoginResource } from "@/shared/oktaResources";
import _ from "lodash";

const HsabPartnerId = 15;

@Component({
  components: {}
})

export default class EmployerPortalOktaLogin extends Vue {
  userStore = useUserStore();
  themeStore = useThemeStore();
  portalCustomizationStore = usePortalCustomizationStore();

  widget = new OktaSignInWidgetBuilder("#okta-signin-container");
  pageReloading = false;

  mounted () {
    this.loadRequiredResources();
  }

  @Watch("userStore.loggedIn")
  onLoggedIn (newValue) {
    if (newValue === true) {
      this.$router.push(Home);
    }
  }

  @Watch("$route.query.partner")
  onPartnerChanged () {
    this.pageReloading = true;
    window.location.reload();
  }

  @Watch("requiredResourcesLoaded")
  onRequiredResourcesLoaded (newValue) {
    if (newValue === true) {
      this.renderOktaWidget();
    }
  }

  loadRequiredResources () {
    const partnerId = (this.$route.query.partner || this.portalCustomizationStore.partnerId);
    const parsedPartnerId = _.toSafeInteger(partnerId) || HsabPartnerId;
    this.portalCustomizationStore.getPartnerCustomLogo(parsedPartnerId);
    this.themeStore.getTheme({ partnerId: parsedPartnerId, employerId: 0, forceUpdate: true });
  }

  renderOktaWidget () {
    this.widget
      .setLogo(this.imgSrc)
      .setBrandColor(this.themeStore.primaryColor)
      .setForgotPasswordLink(this.forgotPasswordLink)
      .overrideLoginProperties(employerLoginResource)
      .build()
      .showSignInAndSetTokens()
      .then(_ => this.userStore.login({ username: "", logoutOnStart: false }));
  }

  get forgotPasswordLink () {
    return this.$router.resolve({ name: LoginRouteNames.ForgotPassword, query: { authType: AuthType.Okta } }).href;
  }

  get imgSrc () {
    if (!this.portalCustomizationStore.isPartnerCustomLogo) {
      return require("../../assets/hsab-logo.png");
    }

    return this.portalCustomizationStore.partnerLogoSrc;
  }

  get requiredResourcesLoaded () {
    return this.themeStore.themesLoaded && this.portalCustomizationStore.isLoaded && !this.pageReloading;
  }

  destroyed () {
    this.widget.destroyed();
  }
}
